import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ClassNames from "classnames";
import { MIN_CHAR_COUNT_TO_SEARCH_ORGANIZATIONS as MinCharCount } from "../../utilities/Constants";
import DropDown from "react-select";
import ResetPassword from "../common/ResetPassword";
import CheckBox from "../../controls/CheckBox";
import LoginAlerts from "./LoginAlerts";

import * as Actions from "../../actions/ImpersonateActions";
import { resetPassword, unlockUser } from "../../actions/UserActions";
import { getUsersByOrgId } from "../../actions/UsersActions";
import { getVirtualUsersByOrgId } from "../../actions/VirtualUserActions";
import { selectOrganization, clearOrganizations, searchByNameOrSite } from "../../actions/OrganizationActions";

import FilterUtilities from "../../utilities/FilterUtilities";
import { isEnterPressed } from "../../utilities/EventsHelper";
import ValidationHelper from "newApp/utilities/ValidationHelper";
import { UserRolesEnum, ProductEnum } from "@p1s/p1s-common-react/constants";

export class ImpersonationBySearch extends Component {

    constructor (props) {
        super(props);

        this.state = {
            moveLegend: false,
            isShowOnlyAdmins: false,
            isLockFilter: false,
            isLoadingUsers: false
        };

        this.handleChangeOrg = this.handleChangeOrg.bind(this);
        this.handleChangeOrgFilter = this.handleChangeOrgFilter.bind(this);
        this.handleChangeProduct = this.handleChangeProduct.bind(this);
        this.handleChangeUser = this.handleChangeUser.bind(this);
        this.handleLoginClick = this.handleLoginClick.bind(this);

        this.handleOpenUsers = this.handleOpenUsers.bind(this);
        this.handleCloseUsers = this.handleCloseUsers.bind(this);
        this.handleFilterOrganization = this.handleFilterOrganization.bind(this);
        this.handleActivateAndLoginClick = this.handleActivateAndLoginClick.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.getUsers = this.getUsers.bind(this);
        this.handleShowAdminsCheck = this.handleShowAdminsCheck.bind(this);
        this.timerId = undefined;
        this.getVirtualUsers = this.getVirtualUsers.bind(this);
        this.loginToSisenseClick = this.loginToSisenseClick.bind(this);
    }

    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.props.login();
        }
    }

    handleChangeOrg (value) {
        if (value == null) {
            // clear selected organization and filtered organizations
            this.props.clearOrganizations();
        } else {
            this.setState({ isLockFilter: true, isLoadingUsers: true });
            //change Site to OrgId
            var org = this.props.organizations.find(x => x.Site === value.value);
            this.props.selectOrganization(org).then(() => {
                this.setState({ isLockFilter: false, isLoadingUsers: false });
            });
        }
    }

    handleChangeOrgFilter (value) {
        if (!ValidationHelper.isNullOrEmpty(value)) {
            if (value.length < MinCharCount && this.props.organizations.length > 0) {
                this.props.clearOrganizations();
            } else if (value.length >= MinCharCount) {
                var context = this;
                if (this.timerId)
                    clearTimeout(this.timerId);

                this.timerId = setTimeout(function () {
                    context.onSearchByName(value);
                }, 500);
            }
        }
    }

    onSearchByName (value) {
        this.props.searchByNameOrSite(value);
    }

    handleChangeProduct (value) {
        if (value == null) {
            this.props.selectProduct(null);
        } else {
            this.props.selectProduct({ id: value.value, name: value.label });
            // need to check if product is analytics, we need this to load users for virtual user list
            if (value.label == "Analytics") {
                this.setState({ isLockFilter: true, isLoadingUsers: true });
                this.getVirtualUsers().then(() => {
                    this.setState({ isLockFilter: false, isLoadingUsers: false });
                });
            }
        }
    }

    handleChangeUser (value) {
        this.props.selectUser(value);
    }

    handleLoginClick () {
        // When loging into AUR reporting we are going to send the user to Sentri7.
        if (this.props.selectedProduct.name === ProductEnum.AurReporting.name) {
            this.props.selectedProduct.name = "Sentri7";
        }
        this.props.impersonateUser(this.props.selectedUser.Id, this.props.selectedProduct.name);
    }

    handleOpenUsers () {
        this.setState({ moveLegend: true });
    }

    handleCloseUsers () {
        this.setState({ moveLegend: false });
    }

    handleFilterOrganization (options) {
        return options;
    }

    handleActivateAndLoginClick () {
        this.props.unlockUser(
            {
                userId: this.props.selectedUser.Id,
                product: this.props.selectedProduct.name
            }
        );
    }

    handleShowAdminsCheck (e) {
        this.setState({ isShowOnlyAdmins: e.target.checked });
    }

    loginToSisenseClick () {
        this.props.loginToSisense(this.props.selectedOrganization.Id, this.props.selectedUser.Id);
    }


    render () {
        var loginFunc = null;
        var loginButtonText = "Login";
        var loginButtonClasses = ClassNames("btn-primary", "btn");
        var resetButtonClasses = ClassNames("btn-primary", "btn", "hidden");

        if (this.props.selectedUser != null && this.props.selectedUser.IsLocked) {
            loginFunc = this.handleActivateAndLoginClick;
            loginButtonText = "Unlock and Login";
        }
        if (this.props.selectedUser != null && this.props.selectedProduct.name == ProductEnum.Analytics.name) {
            loginFunc = this.loginToSisenseClick;
            loginButtonText = "Login";
        }
        else if (this.props.selectedUser != null) {
            loginFunc = this.handleLoginClick;
            loginButtonClasses = ClassNames("btn-primary", "btn");
            loginButtonText = "Login";
            if (this.props.selectedUser.IsPasswordExpired) {
                resetButtonClasses = ClassNames("btn-secondary-action", "btn");
            }
        }

        else if (this.props.selectedUser == null) {
            loginButtonClasses = ClassNames("btn-primary", "btn", "hidden");
        }

        return (<div>
            <div id="inputGroup">
                <div className="inputGroup" id="organizations">
                    <div className="formControlTitle">Site</div>

                    <DropDown onChange={this.handleChangeOrg}
                        value={this.props.selectedOrganization != null ? this.props.selectedOrganization.Site : null}
                        className="picker-hollow" options={this.getOrganizations()}
                        isLoading={this.state.isLockFilter}
                        type="text"
                        onInputChange={this.handleChangeOrgFilter}
                        filterOptions={this.handleFilterOrganization}
                        onBlurResetsInput={false}/>
                </div>

                <div className="inputGroup" id="products">
                    <div className="formControlTitle">Products</div>
                    <DropDown ref="products"
                        onChange={this.handleChangeProduct}
                        tabIndex="7"
                        value={this.props.selectedProduct != null ? this.props.selectedProduct.id : null}
                        options={this.getProducts()}
                        className="picker-hollow" type="text"/>
                </div>

                <div className="inputGroup" id="users">
                    <div className="formControlTitle">Users</div>
                    <DropDown onOpen={this.handleOpenUsers}
                        onClose={this.handleCloseUsers}
                        optionRenderer={rowOptions} ref="users" tabIndex="8"
                        onChange={this.handleChangeUser}
                        value={this.props.selectedUser != null ? this.props.selectedUser.Login : null}
                        isLoading={this.state.isLoadingUsers}
                        options={this.getUsers()}
                        className="picker-hollow" type="text"/>
                </div>

                <div id="showAdminsGroup" className="checkbox checkbox-primary" style={{ display: "inline-block" }}>
                    <CheckBox id="showAdmins" checked={this.state.isShowOnlyAdmins}
                        onChange={this.handleShowAdminsCheck} title="Show Admin Users Only"/>
                </div>
            </div>

            <div id="resetPasswordGroup">
                <ResetPassword visible={this.props.user.newPassword ? true : false}
                    newPassword={this.props.user.newPassword} login={this.props.user.login}/>
            </div>

            <LoginAlerts show={this.state.moveLegend}/>

            <div id="buttonsContainer">
                <button className={resetButtonClasses} id="resetButton" tabIndex="9" onClick={this.resetPassword}>
                    Reset Password
                </button>

                <button className={loginButtonClasses} id="impersonateButton.search" tabIndex="9" onClick={loginFunc}>
                    {loginButtonText}
                </button>
            </div>
        </div>);
    }

    renderValue (option) {
        return option.Id;
    }

    getUsers () {
        const isShowOnlyAdmins = this.state.isShowOnlyAdmins;
        const selectedProduct = this.props.selectedProduct;

        if (this.props.selectedOrganization == null || this.props.selectedProduct == null) {
            return null;
        }

        if (selectedProduct.name == ProductEnum.Analytics.name) {
            const virtualUsers = this.props.virtualUsers.filter(user => {
                if (isShowOnlyAdmins && user.VirtualProfileId == UserRolesEnum.StandardUserProfileId) {
                    return false;
                }
                return true;
            });

            const adminProductRoleName = "Administrator";
            const defaultProductRoleName = "Default User";

            return virtualUsers.map(user => {
                var roleName = user.VirtualProfileId == UserRolesEnum.StandardUserProfileId ? defaultProductRoleName : adminProductRoleName;
                return {
                    label: user.LastName + ", " + user.FirstName + " (" + roleName + ")",
                    value: user.Id,
                    Id: user.Id,
                    Login: user.Id
                };
            });
        }

        const users = this.props.users.filter(user => {
            return user.userProducts.some(product => {
                if (isShowOnlyAdmins && !product.isRoleAdmin) {
                    return false;
                }
                if (selectedProduct.name === "Sentri7") {
                    return user.team === "Pharmacy" && product.productId === selectedProduct.id;

                } else if (selectedProduct.name === "Sentri7Documentation"){
                    return user.team === "Infection Prevention" && product.productId === selectedProduct.id;
                }
                return product.productId === selectedProduct.id;
            });
        });

        return users.map(user => {
            var product = user.userProducts.find(prod => prod.productId === selectedProduct.id);
            return {
                label: user.lastName + ", " + user.firstName + " (" + product.roleName + ")",
                value: user.login,
                IsLocked: user.isLocked,
                IsPasswordExpired: user.isPasswordExpired,
                Login: user.login,
                Id: user.id
            };
        });
    }

    getOrganizations () {
        return this.props.organizations.sort(FilterUtilities.sortOrgByName).map((item) => ({ value: item.Site, label: item.Name }));
    }

    getVirtualUsers () {
        const parentOrganizationId = this.props.selectedOrganization.ParentOrganizationId || this.props.selectedOrganization.Id;
        return this.props.getVirtualUsers(parentOrganizationId, ProductEnum.Analytics.id, this.props.selectedOrganization.Id);
    }

    getProducts () {
        if (this.props.selectedOrganization == null) {
            return null;
        }
        const legacyProducts = this.props.selectedOrganization.Products.sort(FilterUtilities.sortProductByName).map(item => {
            return { value: item.ProductId, label: item.ProductName };
        });

        if (this.props.selectedOrganization.VirtualProductIds?.some(vp => vp == ProductEnum.Analytics.id)) {
            legacyProducts.unshift({ value: 999, label: "Analytics" });
        }

        if (this.props.selectedOrganization.VirtualProductIds?.some(vp => vp == ProductEnum.AurReporting.id)) {
            legacyProducts.find(x => x.label === "Sentri7").label = ProductEnum.AurReporting.name;
        }

        return legacyProducts;
    }

    resetPassword () {
        var id = this.props.selectedUser.Id;
        const login = this.props.selectedUser.Login;
        this.props.resetPassword(id, login);
    }
}

const rowOptions = (option) => {

    var lockClass = ClassNames("glyphicon");
    var expiredClass = ClassNames("glyphicon");
    if (option.IsLocked) {
        lockClass = ClassNames(lockClass, "glyphicon-lock");
    }
    if (option.IsPasswordExpired) {
        expiredClass = ClassNames(expiredClass, "glyphicon-warning-sign");
    }
    return <div>{option.label}&nbsp;&nbsp;&nbsp;<span className={lockClass}/><span className={expiredClass}/></div>;
};

ImpersonationBySearch.defaultProps = {
    organizations: [],
    user: {}
};

ImpersonationBySearch.propTypes = {
    organizations: PropTypes.array,
    users: PropTypes.array,
    selectedUser: PropTypes.object,
    selectedOrganization: PropTypes.object,
    user: PropTypes.object,
    searchByNameOrSite: PropTypes.func,
    virtualUsers: PropTypes.array,
    getVirtualUsers: PropTypes.func,
    loginToSisense: PropTypes.func
};

const mapStateToProps = state => ({
    organizations: state.impersonateState.organizations,
    selectedUser: state.impersonateState.selectedUser,
    selectedOrganization: state.impersonateState.selectedOrganization,
    selectedProduct: state.impersonateState.selectedProduct,
    user: state.impersonateState.user,
    users: state.impersonateState.users,
    virtualUsers: state.impersonateState.virtualUsers
});

const mapDispatchToProps = (dispatch) => {
    return ({
        resetPassword: (id, login) => dispatch(resetPassword(id, login)),
        selectOrganization: (organization) => {
            dispatch(selectOrganization(organization));
            const excludeInactive = true;
            const filterByProductId = null;
            const filterByTeamId = null;
            return dispatch(getUsersByOrgId(organization.Id, excludeInactive, filterByProductId, filterByTeamId));
        },
        getVirtualUsers: (parentOrganizationId, analyticsVirtualProductId, organizationId) => dispatch(getVirtualUsersByOrgId(parentOrganizationId, analyticsVirtualProductId, organizationId)),
        clearOrganizations: () => dispatch(clearOrganizations()),
        searchByNameOrSite: (value) => dispatch(searchByNameOrSite(value)),
        selectUser: (value) => dispatch(Actions.selectUser(value)),
        selectProduct:(value) => dispatch(Actions.selectProduct(value)),
        impersonateUser: (userId, productName) => dispatch(Actions.impersonateUser(userId, productName)),
        unlockUser: (userId, productId) => dispatch(unlockUser(userId, productId)),
        loginToSisense: (orgId, virtualUserId) => dispatch(Actions.loginToSisense(orgId, virtualUserId))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonationBySearch);
